<template>
  <div class="row g-2 mb-2">
    <div v-for="card in displayCards" :key="card.label" class="col-md-3 col-6">
      <div class="stat-glass-card">
        <div class="stat-label">{{ card.label }}</div>
        <div class="stat-value">{{ card.display }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "ReportSummaryCards",
  props: {
    cards: { type: Array, default: () => [] },
  },
  computed: {
    ...mapGetters(["currencySymbol"]),
    displayCards() {
      // Recompute when operating currency changes in settings.
      void this.currencySymbol;
      return this.cards.map((card) => ({
        label: card.label,
        display:
          card.format === "money"
            ? this.formatMoney(card.value)
            : card.value ?? "—",
      }));
    },
  },
};
</script>
